//3rd Party components
import React, { Fragment } from 'react';
import axios from 'axios';
import { Switch, Route } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from 'react-router-dom';

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import Header from '../components/CASA/Header';
import CasaFooter from '../components/CASA/Footer';
import Container from '../components/CASA/Container';
import HomePageRoute from '../components/Portal/HomePageRoute';
import PageAlert from '../components/Portal/PageAlert';
import KeepAlive from "../components/Portal/KeepAlive";
import TimeoutWarning from '../components/Portal/TimeoutWarning';

//Forms
import IndustryAssist from '../forms/IndustryAssist';
import MTONotificationOfTraining from '../forms/MTONotificationOfTraining';
import DigitalLicenceVerification from '../forms/DigitalLicenceVerification';

import VerificationPage from '../pages/VerificationPage/VerificationPage';
import { VerificationScanPage } from '../pages/VerificationPage/VerificationScanPage';

import AsicVerification from '../forms/AsicVerification';
import AircraftConfirmation from "../forms/AircraftConfirmation";
import SubmissionCancellation from "../forms/SubmissionCancellation";

import { DronesRenewInd } from '../forms/DronesRenewInd';
import { DronesRenewOrg } from '../forms/DronesRenewOrg';
import { DroneRegistration, DroneRenewal, DroneAccreditationSelector, CommercialAccreditation, RecreationalAccreditation } from 'forms';
import { ArnApplication, ArnApplicationDvsMethod } from '../forms/ARN';
import PoiVerificationApplication from '../forms/POIVerification/PoiVerificationApplication'

//Pages
import { ErrorPage } from "../pages/ErrorPage";
import { PageNotFoundPage } from "../pages/PageNotFoundPage";
import { LogoutPage } from "../pages/LogoutPage";
import { TimedOutPage } from "../pages/TimedOutPage";
import AdditionalPaymentPage from "./Payment/AdditionalPaymentPage";

import FormSelectorPage from "../pages/FormSelectorPage";
import { ProfileSelectorPage } from "../pages/ProfileSelectorPage";
import { ProfileIndPage } from '../pages/ProfileIndPage';
import { ProfileOrgPage } from '../pages/ProfileOrgPage';
import { ProfileDetailsIndPage } from "../pages/ProfileDetailsIndPage";
import { ProfileDetailsOrgPage } from "../pages/ProfileDetailsOrgPage";

import { ManageRPAPage } from '../pages/ManageRPAPage';
import { SingleRPAPage } from '../pages/SingleRPAPage';
import { ManageAircraftIndPage } from '../pages/ManageAircraftIndPage';
import { ManageAircraftOrgPage } from '../pages/ManageAircraftOrgPage';
import { SingleAircraftIndPage } from '../pages/SingleAircraftIndPage';
import { SingleAircraftOrgPage } from '../pages/SingleAircraftOrgPage';
import { ActiveAlertPage } from '../pages/ActiveAlertPage';
import { ShowCommAccredPage } from '../pages/ShowCommAccredPage';
import { ShowRecAccredPage } from '../pages/ShowRecAccredPage';
import { PilotLicenceDetailsPage } from '../pages/PilotLicenceDetailsPage';
import { ArocDetailsPage } from '../pages/ArocDetailsPage';
import { ServiceUnavailable } from '../pages/ServiceUnavailable';
import { DVSServiceUnavailable } from '../pages/DVSServiceUnavailable';

import RequestAdditionalPayment from '../forms/RequestAdditionalPayment';
import OrgManageUsersPage from '../pages/OrgManageUsersPage';

import OrganisationRouteRouter from './Organisation/OrganisationRouteRouter/OrganisationRouteRouter';
import { POIPage } from './POIPage';

//Actions
import { getEnvData, FETCH_ENVDATA_SUCCESS } from '../PortalStore/Actions/EnvDataActions';
import { getExtId, FETCH_EXTID_SUCCESS, FETCH_EXTID_MISSING } from '../PortalStore/Actions/ExtIdActions';
import { getUserDetails, FETCH_USERDETAILS_SUCCESS } from '../PortalStore/Actions/UserDetailsActions';
import { getTagsIndividual, FETCH_TAGSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/TagsIndividualActions';
import { getSRARNsIndividual, FETCH_SRARNSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/SRARNsIndividualActions';
import { getParticipants, FETCH_PARTICIPANTS_SUCCESS } from '../PortalStore/Actions/ParticipantsActions';
import { getAcceptedSRsIndividual, FETCH_ACCEPTEDSRSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AcceptedSRsIndividualActions';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getFormPropertiesSelector } from '../FormStore/Selectors/FormDataSelectors'

// Contexts
import { DroneContextProvider } from 'contexts/DroneContext';
import { LmsContextProvider } from 'contexts/LmsContext';
import { OrganisationContextProvider } from 'contexts/OrganisationContext';
import { ArnContextProvider } from 'contexts'

export const HomePage = () => {
    const [pageP1, setPageP1] = useState([{ loaded: false, error: false }]);
    const [pageP2, setPageP2] = useState([{ loaded: false, error: false }]);
    const [pageP3, setPageP3] = useState([{ loaded: false, error: false }]);

    const dispatch = useDispatch();

    let userdetails = useSelector(state => state.userdetails);
    let formProperties = useSelector(state => getFormPropertiesSelector(state.formStore));
    const B2CSettings = useSelector(state => state.B2CSettings.items);
    const envdata = useSelector(state => state.envdata.items);
    let pageAlert = useSelector(state => state.pageAlert);
    let extid = useSelector(state => state.extid);

    let urlAEM = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlDraft = useSelector(state => getUrlSelector(state, "Portal - AEM Draft Service URL"));
    let exitModalData = useSelector(state => state.pageAlert);

    const loadEnvData = (webappurl, accesstoken) => {
        axios.all([
            dispatch(getEnvData(webappurl, accesstoken))
        ])
            .then(axios.spread((envres) => {
                if (envres.type === FETCH_ENVDATA_SUCCESS) {
                    setPageP1({ loaded: true, error: false });
                }
                else {
                    setPageP1({ loaded: true, error: true });
                    dispatch(addPageAlert({ level: "error", title: "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.", message: "Details: System error (Code: HP.1)" }));
                }
            }));
    }

    const checkExtId = (webappurl, accessToken, count) => {
        axios.all([
            dispatch(getExtId(webappurl, accessToken))
        ])
            .then(axios.spread((extidres) => {
                if (extidres.type === FETCH_EXTID_SUCCESS) {
                    setPageP2({ loaded: true, error: false });
                }
                else {
                    if (extidres.type === FETCH_EXTID_MISSING) {
                        //wait 10 secs and try again
                        count = count + 1;
                        if (count < 5) {
                            setTimeout(function () { checkExtId(webappurl, accessToken, count); }, 10000);
                        }
                        else {
                            setPageP2({ loaded: true, error: true });
                            dispatch(addPageAlert({ level: "error", title: "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.", message: "Details: System error (Code: HP.2a)" }));
                        }
                    }
                    else {
                        setPageP2({ loaded: true, error: true });
                        dispatch(addPageAlert({ level: "error", title: "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.", message: "Details: System error (Code: HP.2b)" }));
                    }
                }
            }));
    }

    const getHomePageData = (webappurl, accessToken) => {
        //const aemurl = urlAEM + urlDraft;
        axios.all([
            dispatch(getUserDetails(webappurl, accessToken)),
            dispatch(getTagsIndividual(webappurl, accessToken)),
            dispatch(getSRARNsIndividual(webappurl, accessToken)),
            dispatch(getParticipants(webappurl, accessToken)),
            dispatch(getAcceptedSRsIndividual(webappurl, accessToken))
        ])
            .then(axios.spread((userres, tagsres, srarnsres, partsres, accsrres) => {
                if (userres.type === FETCH_USERDETAILS_SUCCESS
                    && tagsres.type === FETCH_TAGSINDIVIDUAL_SUCCESS
                    && srarnsres.type === FETCH_SRARNSINDIVIDUAL_SUCCESS
                    && partsres.type === FETCH_PARTICIPANTS_SUCCESS
                    && accsrres.type === FETCH_ACCEPTEDSRSINDIVIDUAL_SUCCESS
                ) {
                    setPageP3({ loaded: true, error: false });
                }
                else {
                    setPageP3({ loaded: true, error: true });
                    dispatch(addPageAlert({ level: "error", title: "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.", message: "Details: System error (Code: HP.3)" }));
                }
            }));
    }

    // //runs first - once
    // useEffect(() => {
    //     window.history.back();
    // }, [goBack])
    //runs first - once
    useEffect(() => {
        //envdata load
        loadEnvData(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal);
        setPageP1({ loaded: false, error: false });
    }, [])

    //runs second - load extid 
    useEffect(() => {
        if (pageP1.loaded && !pageP1.error && !extid.hasExtid) {
            checkExtId(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, 0);
            setPageP2({ loaded: false, error: false });
        }
    }, [pageP1.loaded, extid.hasExtid])

    //runs third - load homepage data
    useEffect(() => {
        if (pageP2.loaded && !pageP2.error) {
            getHomePageData(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal);
            setPageP3({ loaded: false, error: false });
        }
    }, [pageP2.loaded])

    const showPageAlert = () => {
        if (pageAlert.level !== '') {
            return (
                <PageAlert level={pageAlert.level} title={pageAlert.title} message={pageAlert.message} />
            );
        }
        else {
            return null;
        }
    }

    const setKeepAlive = () => {
        if (!B2CSettings.standalone) {
            return (<KeepAlive />);
        }
    }

    if (!pageP3.loaded && !(pageP1.error || pageP2.error || pageP3.error)) {
        return (

            <Fragment>
                <MetaTags>
                    <title>CASA Portal</title>
                </MetaTags>

                <Header />

                <Container show={true}>

                    <CASASpinner message="Working. Please wait....." />

                </Container>

                <CasaFooter />

            </Fragment>

        );
    }
    else {
        if (pageP1.error || pageP2.error || pageP3.error) {
            return (

                <Fragment>
                    <MetaTags>
                        <title>CASA Portal</title>
                    </MetaTags>

                    <Header />

                    {showPageAlert()}

                    <CasaFooter />

                </Fragment>

            );
        }
        else {
            return (
                <BrowserRouter basename="/forms">

                    <Fragment>

                        <MetaTags>
                            <title>CASA Portal</title>
                        </MetaTags>

                        <Header />

                        <Container show={true}>

                            {userdetails !== null && userdetails.loaded && userdetails.items.value[0] !== null && userdetails.items.value[0].emailaddress1 !== "" ? <TimeoutWarning /> : null}

                            <Switch>

                                <Route path='/showrecaccred'>
                                    <ShowRecAccredPage />
                                </Route>

                                <Route path='/showcommaccred'>
                                    <ShowCommAccredPage />
                                </Route>

                                <Route path='/licence-view-multiple'>
                                    <PilotLicenceDetailsPage />
                                </Route>

                                <Route path='/aroc-details'>
                                    <ArocDetailsPage />
                                </Route>

                                <Route path="/licence-view/asic-verification">
                                    <AsicVerification />
                                </Route>

                                <Route
                                    path="/digitallicence/verification/verification-view/:token?/:licenceType?"
                                    render={(props) => (
                                        <VerificationPage {...props} />
                                    )}>
                                </Route>

                                <Route path="/digitallicence/verification/submit">
                                    <DigitalLicenceVerification />
                                </Route>

                                <Route exact path="/digitallicence/verification">
                                    <VerificationScanPage />
                                </Route>

                                {/* <Route path="/industry-assist"> //https://casaau.visualstudio.com/Digital%20Enhancement%20Project/_workitems/edit/153854
                                    <IndustryAssist />
                                </Route> */}

                                <Route path="/mto-notification-of-training-outcomes">
                                    <MTONotificationOfTraining />
                                </Route>

                                <Route path="/aircraft/confirmation">
                                    <AircraftConfirmation />
                                </Route>

                                <Route path="/submissions/:submissionId/cancellation">
                                    <SubmissionCancellation />
                                </Route>

                                <Route exact path="/formselector">
                                    <FormSelectorPage />
                                </Route>

                                <Route exact path="/orgmanageusers">
                                    <OrgManageUsersPage />
                                </Route>

                                <Route exact path="/manageaircraftorg">
                                    <ManageAircraftOrgPage />
                                </Route>

                                <Route exact path="/manageaircraftind">
                                    <ManageAircraftIndPage />
                                </Route>

                                <Route exact path="/singleaircraftind">
                                    <SingleAircraftIndPage />
                                </Route>

                                <Route exact path="/singleaircraftorg">
                                    <SingleAircraftOrgPage />
                                </Route>

                                <Route exact path="/activealert">
                                    <ActiveAlertPage />
                                </Route>

                                <Route exact path="/submissions/:submissionId/payment">
                                    <RequestAdditionalPayment />
                                </Route>

                                <Route exact path="/submissions/payment">
                                    <AdditionalPaymentPage />
                                </Route>

                                <Route exact path="/dronesrenewind">
                                    <DronesRenewInd />
                                </Route>

                                <Route exact path="/dronesreneworg">
                                    <DronesRenewOrg />
                                </Route>

                                <Route exact path="/drone-registration">
                                    <DroneContextProvider>
                                        <DroneRegistration />
                                    </DroneContextProvider>
                                </Route>

                                <Route exact path="/drone-renewal">
                                    <DroneContextProvider>
                                        <DroneRenewal />
                                    </DroneContextProvider>
                                </Route>

                                <Route exact path="/drone-accreditation">
                                    <DroneAccreditationSelector />
                                </Route>

                                <Route exact path="/drone-accreditation/commercial">
                                    <LmsContextProvider assessmentType='RPA Excluded Assessment'>
                                        <CommercialAccreditation />
                                    </LmsContextProvider>
                                </Route>

                                <Route exact path="/drone-accreditation/recreational">
                                    <LmsContextProvider assessmentType='RPA Recreational Assessment'>
                                        <RecreationalAccreditation />
                                    </LmsContextProvider>
                                </Route>

                                <Route exact path="/profileselector">
                                    <ProfileSelectorPage />
                                </Route>

                                <Route exact path="/profiledetailsind">
                                    <ProfileDetailsIndPage />
                                </Route>

                                <Route exact path="/profiledetailsorg">
                                    <ProfileDetailsOrgPage />
                                </Route>

                                <Route exact path="/indmanagerpa">
                                    <ManageRPAPage />
                                </Route>

                                <Route exact path="/orgmanagerpa">
                                    <ManageRPAPage />
                                </Route>

                                <Route exact path="/singlerpa">
                                    <SingleRPAPage />
                                </Route>

                                <Route exact path="/dashind">
                                    <ProfileIndPage />
                                </Route>

                                <Route exact path="/dashorg">
                                    <ProfileOrgPage />
                                </Route>
                                {/* Organisation route for all organisation */}
                                <Route path="/organisation/:organisationId">
                                    <OrganisationContextProvider>
                                        <OrganisationRouteRouter />
                                    </OrganisationContextProvider>
                                </Route>

                                <Route exact path="/error">
                                    <ErrorPage />
                                </Route>

                                <Route exact path="/serviceunavailable">
                                    <ServiceUnavailable />
                                </Route>      

                                <Route exact path="/dvsserviceunavailable">
                                    <DVSServiceUnavailable />
                                </Route>                           

                                <Route exact path="/timedout">
                                    <TimedOutPage />
                                </Route>

                                <Route exact path="/logoff">
                                    <LogoutPage />
                                </Route>

                                <Route exact path="/init-verify-poi">
                                    <POIPage />
                                </Route>
                                <Route exact path="/poiverification" render={(props) => (
                                    <ArnContextProvider>
                                        <PoiVerificationApplication />
                                    </ArnContextProvider>
                                )} />
                                <Route exact path="/arn/:arnType" render={(props) => (
                                    <ArnContextProvider>
                                        <ArnApplication />
                                    </ArnContextProvider>
                                )} />
                                <Route exact path="/arn-dvs/:arnType" >
                                    <ArnContextProvider>
                                        <ArnApplicationDvsMethod />
                                    </ArnContextProvider>
                                </Route>
                                

                                <HomePageRoute exact path="/" />

                                {/*leave as last item in this switch statement*/}
                                <Route>
                                    <PageNotFoundPage />
                                </Route>

                            </Switch>

                        </Container>

                        <CasaFooter />

                        {setKeepAlive()}

                    </Fragment>

                </BrowserRouter>
            );
        }
    }

}
